export const SET_MESSAGE = "SET_MESSAGE";
export const SHOW_ERROR = "SHOW_ERROR";
export const SET_LOADING = "SET_LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const CLEAR_ERROR = "CLEAR_ERROR";
